import { routeUrls as routeUrl } from '../RouteUrls';
import { SilentRenewPage } from '../../../pages/SilentRenewPage';

export function SignInRoutes() {
  return [
    {
      path: routeUrl.signIn.path,
      element: null,
    },
    {
      path: routeUrl.signInRefresh.path,
      Component: SilentRenewPage,
    },
  ];
}
